<template>
  <button
    v-bind="$attrs"
    :type="type"
    :disabled="disabled"
    :class="[
      'flex cursor-pointer items-center justify-center border transition focus:outline-none',
      {[`${colorValriants[color]} border-transparent text-white`]: color && !outline},
      {[`${outlineValriants[outline]} bg-white`]: outline && !color},
      {[`${colorValriants[color]} ${outlineValriants[outline]}`]: color && outline},
      {
        ['rounded-[6px] px-[15px] py-[3px]']: size === 'sm'
      },
      {
        ['rounded-[10px] px-4 py-3']: size === 'md'
      },
      {
        ['rounded-[10px] px-6 py-4']: size === 'lg'
      },
      {
        ['w-full rounded-[10px] py-4']: size === 'xl'
      },
      {
        'disabled:cursor-default disabled:border-slate-300 disabled:bg-slate-100 disabled:text-disabled': disabled
      },
      {'rounded-full': round}
    ]"
    :data-testid="dataTestid"
    @click="$emit('clickEvent')"
  >
    <slot />
  </button>
</template>

<script setup>
defineEmits(['clickEvent'])
defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'button'
  },
  color: {
    type: [String, Boolean],
    default: false
  },
  outline: {
    type: [String, Boolean],
    default: false
  },
  size: {
    type: String,
    required: true //sm, md, lg, xl
  },
  round: {
    type: Boolean,
    default: false
  },
  dataTestid: {
    type: String,
    default: ''
  }
})
const colorValriants = {
  primary: 'bg-primary-500 hover:bg-primary-600',
  gray: 'bg-slate-400 hover:bg-slate-500',
  blue: 'bg-blue-600 hover:bg-blue-700'
}
const outlineValriants = {
  primary: 'border-slate-600 hover:border-primary-500 hover:bg-primary-50 hover:text-primary-500 check:border-2',
  gray: 'border-slate-400 hover:bg-slate-100',
  blur: 'border-blue-600 text-blue-600 text-base'
}
</script>

<style></style>
